/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Quota_LabelInputs */

const en_why_listening_quota_label = /** @type {(inputs: Why_Listening_Quota_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No quotas`)
};

const es_why_listening_quota_label = /** @type {(inputs: Why_Listening_Quota_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin límites`)
};

/**
* | output |
* | --- |
* | "No quotas" |
*
* @param {Why_Listening_Quota_LabelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_quota_label = /** @type {((inputs?: Why_Listening_Quota_LabelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Quota_LabelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_quota_label(inputs)
	return en_why_listening_quota_label(inputs)
});